import { useTemplateBuilderContext } from 'components/Templates/builder/context/template-builder.context.tsx';
import { useAppSelector } from 'rtk/query/hooks.ts';
import { selectQuestionMode } from 'rtk/questionEditorSelector.ts';
import { ETemplateRevision } from 'rtk/TemplateSlice.ts';
import { ECreateQuestionMode } from '../context/create-question.context.tsx';

const TemplateEditInfoText = ({ questionId }: { questionId: string }) => {
  const mode = useAppSelector((state) => selectQuestionMode(state, questionId));
  const isPublishedOrNonExclusiveQuestion = useAppSelector(
    (state) => state.questionEditor.byId[questionId]?.isPublishedOrNonExclusiveQuestion,
  );
  const { revision } = useTemplateBuilderContext();

  if (mode !== ECreateQuestionMode.InTemplateEdit || revision !== ETemplateRevision.Draft) {
    return null;
  }

  return (
    <div className="rounded-md border border-amber-200 bg-amber-50 p-2.5">
      {/* TODO(i18n): Category 4 — "Template specific changes" heading can be extracted; deferred with the sentences below */}
      <p className="text-xs font-semibold text-amber-900">Template specific changes</p>
      <div className="mt-1 text-xs leading-5 text-amber-800">
        {/* TODO(i18n): Category 4 — <span className="underline"> splits "this" mid-sentence */}
        <p>
          All edits made here will only update the question in <span className="underline">this</span> template.
        </p>
        <p className="mt-1">
          {isPublishedOrNonExclusiveQuestion ? (
            <>
              {/* TODO(i18n): Category 4 — <span className="italic"> wraps "Go to question" mid-sentence */}
              To update the question in all templates, click <span className="italic">Go to question</span> above.
            </>
          ) : (
            <>
              {/* TODO(i18n): Category 4 — <span className="italic"> wraps "Update question" mid-sentence */}
              To update the question itself, click <span className="italic">Update question</span> in the bottom right
              after you've made your edits.
            </>
          )}
        </p>
      </div>
    </div>
  );
};

export default TemplateEditInfoText;
